import {
  Dropdown,
  Menu,
  Avatar,
} from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { getAvatar, isInternal } from '@/infrastructure/auth';
import { logoutByHistory } from '@/infrastructure/logout';
import { ConfigTabType } from '@/presentation/pages/setting/app-deliver-config/api';
import { stores } from '@/presentation/store';

export const AvatarMenu = () => {
  const history = useHistory();
  const { setCopilotVisible } = stores.LayoutStore;

  const handleSelect = (key: string) => {
    setCopilotVisible(false);
    if (key === 'myApp') {
      history.push('/workbench/apps');
    } else if (key === 'profile') {
      history.push('/user/profile');
    } else if (key === 'token') {
      history.push('/user/token');
    } else if (key === 'config-manage') {
      history.push(`/config-manage?bar=${ConfigTabType.DEFAULT}`);
    } else {
      logoutByHistory(history);
    }
  };

  const menu = () => (
    <Menu onClick={({ key }) => handleSelect(key)}>
      <Menu.Item key="myApp">
        我的产品
      </Menu.Item>
      {isInternal() && <Menu.Item key="profile">
        个人信息
      </Menu.Item>}
      <Menu.Item key="token">
        个人令牌
      </Menu.Item>
      {/* {isSuperUser && <Menu.Item key="config-manage">
        配置管理
      </Menu.Item>} */}
      <Menu.Item key="logout">
        退出登录
      </Menu.Item>
    </Menu>
  );

  return <Dropdown overlay={menu} placement={'bottomRight'}>
    <Avatar style={{ marginBottom: '5px' }} size={28} src={getAvatar()} />
  </Dropdown>;
};
